import React from 'react';
import { Construction } from 'lucide-react';
import CmsManagedInfoPage from '../components/site/CmsManagedInfoPage';

const SalePageFallback: React.FC = () => (
  <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
    <main className="flex-grow">
      <div className="bg-gray-50 py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-md mx-auto">
            <Construction className="w-16 h-16 text-blue-600 mx-auto mb-6" />
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Sale</h1>
            <p className="text-xl text-gray-600 mb-8">
              Find amazing deals and discounts on our featured products.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <p className="text-blue-800">
                We&apos;re working hard to bring you the best shopping experience. In the meantime, feel free to browse
                our products or contact our support team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
);

const SalePage: React.FC = () => <CmsManagedInfoPage route="/sale" fallback={<SalePageFallback />} />;

export default SalePage;
